import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const ZIcon = ({url}) => { 
    return (
        <img className="z-icon-image" src={window.isNFT ? url : "/" + url}/>
    );
}

const mapStateToProps = (state, props) => {
  return {
      url: props.zobject.effect.url
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZIcon);
